import { partyCardStatusBarCssDefs } from 'components/service/party/partyRedesignCard/partyCardCssDefs';
import { useIsCompactView } from 'hooks/useIsCompactView';

type StatusBarProps = {
  barColor: string;
};

/**
 * Indicator for party and waitlist cards that adjusts display to fit the
 * card layout (compact or standard)
 */
export const StatusBar = ({ barColor }: StatusBarProps) => {
  const isCompactView = useIsCompactView();

  return (
    <div
      data-testid="statusBar"
      css={partyCardStatusBarCssDefs.statusBar({
        isCompactView,
        barColor,
      })}
    />
  );
};
